import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { Query } from "@oysterhr/schema"

const QUERY = gql`
  query PlanConfigData($enrollmentId: ID!) {
    benefitsEnrollment(enrollmentId: $enrollmentId) {
      dependents {
        collection {
          id
        }
      }
      engagement {
        dependents {
          collection {
            id
            fieldsWithValues
          }
        }
      }
      plan {
        maxDependents
        name
        provider {
          name
        }
      }
    }
  }
`

export function useDependents(enrollmentId: string) {
  return useQuery<Pick<Query, "benefitsEnrollment">>(QUERY, {
    variables: {
      enrollmentId,
    },
    fetchPolicy: "network-only",
  })
}
